/**
 * --------------------------------------------
 * KANYOS LoadingWrapper.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'LoadingWrapper'
const DATA_KEY = 'lte.loadingwrapper'
// const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const CLASS_NAME_LOADING_PANEL = 'loading-panel'
const CLASS_NAME_LOADING_TRIGGER = 'loading-trigger'

// const EVENT_CHANGED = `changed${EVENT_KEY}`

const SELECTOR_DATA_TOGGLE = '[data-widget="loading-wrapper"]'

const Default = {
  preloaderEnabled: true,
  preloaderImage: '',
  preloaderTemplate: '<div class="preloader flex-column justify-content-center align-items-center"><img class="animation__shake" src="{{preloaderImage}}"></div>',
  loadingEnabled: true,
  loadingImage: '',
  loadingTemplate: '<div class="loading"><div class="loading-mask"></div><div class="loading-wrapper"><img src="{{loadingImage}}"></div></div>'
}

/**
 * Class Definition
 * ====================================================
 */

class LoadingWrapper {
  constructor(element, config) {
    this._config = config
    this._element = element
    this._preloaderOverlay = $(this._config.preloaderTemplate.replace(/{{preloaderImage}}/g, this._config.preloaderImage))
    this._loadingOverlay = $(this._config.loadingTemplate.replace(/{{loadingImage}}/g, this._config.loadingImage))

    this._init()
  }

  show() {
    $(this._loadingOverlay).show()
  }

  hide() {
    $(this._loadingOverlay).hide()
  }

  // Private

  _init() {
    // $(this).find(this._settings.trigger).on('click', () => {
    //   this.load()
    // })

    const $wrapper = $(SELECTOR_DATA_TOGGLE)
    if (!$wrapper.hasClass(CLASS_NAME_LOADING_PANEL)) {
      $wrapper.addClass(CLASS_NAME_LOADING_PANEL)
    }

    if (this._config.loadingEnabled) {
      $wrapper.prepend(this._loadingOverlay)
    }

    if (this._config.preloaderEnabled) {
      $wrapper.prepend(this._preloaderOverlay)
    }

    $(this._loadingOverlay).hide()

    $(document).on('click', this._loadingOverlay, event => {
      if ($(event.target).hasClass(CLASS_NAME_LOADING_TRIGGER) ||
        $(event.target.parentElement).hasClass(CLASS_NAME_LOADING_TRIGGER)) {
        const $loadingClass = 'mobile-block'
        if (!$(event.data).hasClass($loadingClass)) {
          $(event.data).addClass($loadingClass)
        }

        $(event.data).show()
      }
    })
  }

  // Static

  static _jQueryInterface(config) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = $(this).data()
        const _options = $.extend({}, Default, typeof config === 'object' ? config : data)
        data = new LoadingWrapper($(this), _options)
      }

      $(this).data(DATA_KEY, typeof config === 'object' ? config : data)

      if (typeof config === 'string' && /show|hide/.test(config)) {
        data[config]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

$(window).on('load', () => {
  LoadingWrapper._jQueryInterface.call($(SELECTOR_DATA_TOGGLE))
})

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = LoadingWrapper._jQueryInterface
$.fn[NAME].Constructor = LoadingWrapper
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return LoadingWrapper._jQueryInterface
}

export default LoadingWrapper
